'use strict';
import * as $j_app$002edata$002e$002dForm$002dQuantity from "./app.data.-Form-Quantity.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_FormQuantity$$anon$4(fromUnderlying$3, evidence$1$9) {
  this.aBw = null;
  this.aBv = null;
  this.aBw = fromUnderlying$3;
  this.aBv = evidence$1$9;
}
export { $c_Lapp_data_FormQuantity$$anon$4 as $c_Lapp_data_FormQuantity$$anon$4 };
$p = $c_Lapp_data_FormQuantity$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_FormQuantity$$anon$4;
/** @constructor */
function $h_Lapp_data_FormQuantity$$anon$4() {
}
export { $h_Lapp_data_FormQuantity$$anon$4 as $h_Lapp_data_FormQuantity$$anon$4 };
$h_Lapp_data_FormQuantity$$anon$4.prototype = $p;
$p.bYR = (function(underlying) {
  var fromUnderlying$1 = this.aBw;
  var evidence$1$5 = this.aBv;
  return new $j_app$002edata$002e$002dForm$002dQuantity.$c_Lapp_data_FormQuantity(fromUnderlying$1.ak(underlying), evidence$1$5);
});
$p.ak = (function(src) {
  return this.bYR(src);
});
var $d_Lapp_data_FormQuantity$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_FormQuantity$$anon$4, "app.data.FormQuantity$$anon$4", ({
  DG: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_FormQuantity$$anon$4 as $d_Lapp_data_FormQuantity$$anon$4 };
//# sourceMappingURL=app.data.-Form-Quantity$$anon$4.js.map
